import { render, staticRenderFns } from "./SelectBoxCard.vue?vue&type=template&id=456f07a0&scoped=true&"
import script from "./SelectBoxCard.vue?vue&type=script&lang=js&"
export * from "./SelectBoxCard.vue?vue&type=script&lang=js&"
import style0 from "./SelectBoxCard.vue?vue&type=style&index=0&id=456f07a0&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456f07a0",
  null
  
)

export default component.exports